/* eslint-disable */
//const { render } = wp.element;
import CblProduct from './components/CblProduct'
import Allocate from './components/Allocate'
import AllocationDetails from './components/AllocationDetails'
import LoadMorePress from './components/LoadMorePress'
import LoadMoreNews from './components/LoadMoreNews'
import LoadMoreBlogs from './components/LoadMoreBlogs'

import React from 'react';
import ReactDOM from 'react-dom';

if(document.getElementById('cbl-product')) {
    ReactDOM.render(<CblProduct/>, document.getElementById('cbl-product'));
}


if(document.getElementById('h2ox-pricing')) {
    ReactDOM.render(<Allocate/>, document.getElementById('h2ox-pricing'));
}

if(document.getElementById('allocation-details')) {
    ReactDOM.render(<AllocationDetails/>, document.getElementById('allocation-details'));
}

if(document.getElementById('load-more-press')) {
    ReactDOM.render(<LoadMorePress/>, document.getElementById('load-more-press'));
}

if(document.getElementById('load-more-news')) {
    let element = document.getElementById('load-more-news');
    let props = Object.assign({}, element.dataset);
    ReactDOM.render(<LoadMoreNews  {...props} />, element);
}

if(document.getElementById('load-more-blogs')) {
  let element = document.getElementById('load-more-blogs');
  let props = Object.assign({}, element.dataset);
  ReactDOM.render(<LoadMoreBlogs  {...props} />, element);
}

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/app.js